"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = void 0;
var _mui = require("@ori-ui/mui");
var _productList = require("@ori/product-list");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  [`.${_productList.productListClasses.list}`]: {
    gridTemplateColumns: '1fr 1fr',
    [theme.breakpoints.up('sm')]: {
      gridTemplateColumns: '1fr 1fr 1fr'
    }
  }
}));